module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    ref: "popup",
    staticClass: "dialog-wrapper",
    style: ({
      'z-index': _vm.zIndex
    }),
    on: {
      "click": _vm.handleWrapperClick
    }
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.contents), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.clickItem(i)
        }
      }
    }, [_vm._v(_vm._s(item) + "\n      ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('v-button', {
    staticClass: "left",
    attrs: {
      "secondary": "",
      "text": _vm.cancelText
    },
    on: {
      "click": _vm.cancel
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ab3ca2b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/dialog-selector.vue
// module id = 818
// module chunks = 34